import React, { useState } from 'react';
import { DotsVerticalIcon } from '../icons';
import SpecActionSheet from '../SpecActionSheet/SpecActionSheet';
import type { ActionSheetItem } from '../SpecActionSheet/SpecActionSheet';
import './MusicianLinkCard.css';

interface MusicianLinkCardProps {
  title: string;
  url: string;
  isOwner?: boolean;
  onShare?: () => void;
  onCopyLink?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  className?: string;
}

export const MusicianLinkCard: React.FC<MusicianLinkCardProps> = ({
  title,
  url,
  isOwner = false,
  onShare,
  onCopyLink,
  onEdit,
  onDelete,
  className,
}) => {
  const [actionSheetOpen, setActionSheetOpen] = useState(false);

  const handleCardClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActionSheetOpen(true);
  };

  const actionItems: ActionSheetItem[] = [
    ...(onShare ? [{ key: 'share', label: 'Share', onClick: onShare }] : []),
    ...(onCopyLink ? [{ key: 'copy-link', label: 'Copy Link', onClick: onCopyLink }] : []),
    ...(isOwner && onEdit ? [{ key: 'edit', label: 'Edit', onClick: onEdit }] : []),
    ...(isOwner && onDelete ? [{ key: 'delete', label: 'Delete', danger: true, onClick: onDelete }] : []),
  ];

  return (
    <>
      <div className={`musician-link-card ${className || ''}`} onClick={handleCardClick}>
        <span className="musician-link-card__title">{title}</span>
        <button
          className="musician-link-card__menu"
          onClick={handleMenuClick}
          aria-label="More options"
        >
          <DotsVerticalIcon size="m" tone="lightGrey" />
        </button>
      </div>
      <SpecActionSheet
        open={actionSheetOpen}
        onClose={() => setActionSheetOpen(false)}
        items={actionItems}
      />
    </>
  );
};

export default MusicianLinkCard;
